import React, { useContext, useEffect, useState } from "react";
import { BrowserRouter, Switch, useLocation, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import EpoDashboard from "../pages/EpoDashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Projects from "../pages/Projects/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { AuthContext } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import BackdropLoading from "../components/BackdropLoading";
import api from "../services/api";
import Route from "./Route";

const DashboardDispatch = () => {
  const { user } = useContext(AuthContext);
  if (!user) return null;
  return user.profile === "epo" ? <EpoDashboard /> : <Dashboard />;
};

const TitleUpdater = () => {
  const location = useLocation();
  useEffect(() => {
    let pageName = "Dashboard";
    const pathSegment = location.pathname.replace("/", "").split("/")[0];
    if (pathSegment) {
      const spaced = pathSegment.replace(/([A-Z])/g, ' $1').trim();
      pageName = spaced.charAt(0).toUpperCase() + spaced.slice(1);
    }
    document.title = `MessaJO - ${pageName}`;
  }, [location]);
  return null;
};

const Routes = () => {
  const [signupEnabled, setSignupEnabled] = useState(true);
  const [signupStatusLoading, setSignupStatusLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadSignupStatus = async () => {
      try {
        const { data } = await api.get("/auth/signup-status");

        if (isMounted) {
          setSignupEnabled(Boolean(data?.enabled));
        }
      } catch (err) {
        if (isMounted) {
          setSignupEnabled(true);
        }
      } finally {
        if (isMounted) {
          setSignupStatusLoading(false);
        }
      }
    };

    loadSignupStatus();

    return () => {
      isMounted = false;
    };
  }, []);

  const LoginPage = props => (
    <Login
      {...props}
      signupEnabled={signupEnabled}
      signupStatusLoading={signupStatusLoading}
    />
  );

  const SignupPage = props => {

    if (signupStatusLoading) {
      return <BackdropLoading />;
    }

    if (!signupEnabled) {
      return <Redirect to="/login" />;
    }

    return <Signup {...props} />;
  };

  return (
    <BrowserRouter>
      <TitleUpdater />
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            <Route exact path="/login" component={LoginPage} />
            <Route exact path="/signup" component={SignupPage} />
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={DashboardDispatch} isPrivate />
                <Route exact path="/tickets/:ticketId?" component={Tickets} isPrivate />
                <Route exact path="/connections" component={Connections} isPrivate />
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/projects" component={Projects} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route exact path="/quickAnswers" component={QuickAnswers} isPrivate />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer
            autoClose={3000}
            position="bottom-right"
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            draggable={false}
            theme="colored"
          />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
